import React from 'react';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

export const CreateCallDrawer = ({ onClose = () => {}, onSaved = () => {}, jobOrder = null }) => {
  const buttonDefinitions = [
    {
      props: {
        text: 'Cancel',
        variant: 'outlined',
        onClick: onClose
      },
      GridItemProps: { md: 3 }
    },
    {
      props: {
        text: 'Save',
        variant: 'contained',
        onClick: onSaved
      },
      GridItemProps: { md: 3 }
    }
  ];

  return (
    <FPDrawer
      FPDrawerProps={{ open: true }}
      CardHeaderProps={{ title: 'Create Call' }}
      onClose={onClose}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <div>Call editor placeholder{jobOrder}</div>
    </FPDrawer>
  );
};
